import type { CityStats, Grid, ResearchState } from '../../../types';

export const LOAN_AMOUNT = 1000;
export const PITCH_COOLDOWN_DAYS = 25;
export const PITCH_BASE_FUNDING = 1000;
export const PITCH_MAX_BONUS = 2500;
export const PITCH_COMPLIANCE_PENALTY = 10;

export type LoanAction = 'take' | 'repay';
export type EconomyNewsType = 'positive' | 'negative' | 'neutral';
export type EconomySfx = 'success' | 'error' | 'money' | 'click' | 'alert';

export interface LaunchProductInput {
  productId: string;
  grid: Grid;
  stats: CityStats;
}

export interface LaunchProductOutput {
  ok: boolean;
  stats: CityStats;
  skipped?: boolean;
  productName?: string;
  newsMessage?: string;
  newsType?: EconomyNewsType;
  sfx?: EconomySfx;
  error?: string;
}

export interface ProcessLoanInput {
  action: LoanAction;
  stats: CityStats;
  loanAmount?: number;
}

export interface ProcessLoanOutput {
  ok: boolean;
  stats: CityStats;
  newsMessage?: string;
  newsType?: EconomyNewsType;
  sfx?: EconomySfx;
  error?: string;
}

export interface StartResearchProjectInput {
  techId: string;
  stats: CityStats;
  research: ResearchState;
}

export interface StartResearchProjectOutput {
  ok: boolean;
  stats: CityStats;
  research: ResearchState;
  skipped?: boolean;
  newsMessage?: string;
  newsType?: EconomyNewsType;
  sfx?: EconomySfx;
  error?: string;
}

export interface PitchInvestorsInput {
  stats: CityStats;
  hasJumpGate: boolean;
  pitchCooldownDays?: number;
  /** Optional 0–1 roll for deterministic tests; defaults to injected random provider */
  randomRoll?: number;
}

export interface PitchInvestorsOutput {
  ok: boolean;
  stats: CityStats;
  newsMessage?: string;
  newsType?: EconomyNewsType;
  sfx?: EconomySfx;
  playErrorSfx?: boolean;
  error?: string;
  fundingAmount?: number;
}